import { T, useGT } from 'gt-react';
import type { MemoryModule } from '@erp/shared-types';
import { Label } from 'src/components/ui/label';
import {
  MemoryModuleSelect,
  parseMemoryModule,
} from '@/components/harness/MemoryModuleSelect';
import type { ConfigRendererProps } from './types';

/**
 * The "Memory from" setting shared by workflow steps that read memory from
 * one area (`config.memoryModule`). `fallback` is the step's schema default,
 * shown while the config does not carry the key yet.
 */
export function MemoryFromField({
  config,
  onConfigChange,
  readOnly,
  fallback,
  help,
}: Pick<ConfigRendererProps, 'config' | 'onConfigChange' | 'readOnly'> & {
  fallback: MemoryModule;
  /** What the step reads from the area, under the dropdown. */
  help: React.ReactNode;
}) {
  const gt = useGT();
  return (
    <div className="space-y-1">
      <Label className="text-sm">
        <T>Memory from</T>
      </Label>
      <MemoryModuleSelect
        value={parseMemoryModule(config.memoryModule, fallback)}
        disabled={readOnly}
        onChange={(memoryModule) =>
          void onConfigChange({ ...config, memoryModule })
        }
        triggerClassName="h-7 text-xs"
        ariaLabel={gt('Memory from', {
          context: 'Which memory area a workflow step reads memory from',
        })}
      />
      <p className="text-[11px] text-muted-foreground">{help}</p>
    </div>
  );
}
